import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';

/* UI */

/* Helpers */

/* Styles */
import './FooterMainLink.scss';

class FooterMainLink extends Component {
  static propTypes = {
    isOutbound: PropTypes.bool,
    url: PropTypes.string.isRequired,
    linkName: PropTypes.string.isRequired,
    handleRouteStaticRoute: PropTypes.func.isRequired,
  };

  handleUrl = e => {
    e.preventDefault();
    const { handleRouteStaticRoute, url } = this.props;
    handleRouteStaticRoute(url, null, true);
  };

  render() {
    const { isOutbound, linkName, url } = this.props;

    return isOutbound ? (
      <a
        className="Footer-nav-link"
        href={url}
        rel="noopener noreferrer"
        target="_blank"
      >
        {linkName}
      </a>
    ) : (
      <a className="Footer-nav-link" href={url} onClick={this.handleUrl}>
        {linkName}
      </a>
    );
  }
}

export default pure(FooterMainLink);
